export enum RiderVehicleTypeEnum {
    None = 0,
    Moto = 1,
    Sedan = 2,
    SUV = 3,
    Fastest = 4,
    PetTaxi = 5,
    Courier = 6,
    Cargo = 7,
    Food = 8,
    Grocery = 9,
    ETrike = 10,
    Van = 11,
    Minibus = 12,
    Multicab = 13,
    EVCar = 14,
	Taxi = 16,
	EJeepney = 17,
	TrikeSixPax = 18,
	TrikeFivePax = 19,
	Comfort = 20,
	Premium = 21
}
